import { render, staticRenderFns } from "./CommunicationBooksAdminModal.vue?vue&type=template&id=fdfb5338&scoped=true"
import script from "./CommunicationBooksAdminModal.vue?vue&type=script&lang=js"
export * from "./CommunicationBooksAdminModal.vue?vue&type=script&lang=js"
import style0 from "./CommunicationBooksAdminModal.vue?vue&type=style&index=0&id=fdfb5338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfb5338",
  null
  
)

export default component.exports